import { DatePicker, Input, Table, Modal, Button } from "antd";
import React, { Component } from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { httpGet, httpPost, httpUrl, serverUrl } from "../../api/httpClient";
import CoinSelectBox from "../../components/common/CoinSelectBox";
import SelectBox from "../../components/common/SelectBox";
import string from "../../string";
import { amountFormat, formatDate } from "../../util";
import { numberFormat } from "../../util";
import moment from "moment";

const Search = Input.Search;
const { RangePicker } = DatePicker;

class RomarketFranchise extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tables: [],
      searchText: '',
      pagination: {
        total: 0,
        current: 1
      },
    };
  }

  componentDidMount() {
    this.getList();
  }
  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    }, ()=>this.getList());
  };

  onSearch = (value) => {
    this.setState(
      {
        searchText: value
      },
      () => {
        this.getList();
      }
    );
  };
  getList = () => {
    let pageNum = this.state.pagination.current;
    httpGet(httpUrl.romarketFranchiseList,[10,pageNum,this.state.searchText],{}).then((res) => {
      const pagination = { ...this.state.pagination };
      pagination.current = res.data.currentPage;
      pagination.total = res.data.totalCount;
      this.setState({
        tables: res.data.list,
        pagination,
      });
    });
  };

  delete = async (row) => {

    if (global.confirm(row.id + ' 상점을 정말 삭제하시겠습니까?')) {
      const result = await httpPost(httpUrl.romarketFranchiseUpdate, [], {...row, deleted: 1});
      if (result.data) this.getList();
      else alert('삭제에 실패하였습니다.')

    }
  }
  deleteId = async (row) => {

    if (global.confirm(row.usreId + ' 연동정보를 정말 삭제하시겠습니까?')) {
      const result = await httpPost(httpUrl.romarketFranchiseUpdate, [], {...row, serialNum: ''});
      if (result.data) this.getList();
      else alert('삭제에 실패하였습니다.')

    }
  }

  render() {
    const { tables } = this.state;
    const columns = [
      {
        title: "가입일",
        dataIndex: "createDate",
        className: "support-column-number fs-15 lh-21",
        render: value => moment(value, 'YYYYMMDD').format('YYYY-MM-DD')
      },
      {
        title: "아이디(로마켓)",
        dataIndex: "id",
        className: "support-column-number fs-15 lh-21",
      },
      {
        title: "이름",
        dataIndex: "name",
        className: "support-column-number fs-15 lh-21",
      },
      {
        title: "사업자번호",
        dataIndex: "businessNumber",
        className: "support-column-number fs-15 lh-21",
      },
      {
        title: "주소",
        dataIndex: "address",
        className: "support-column-number fs-15 lh-21",
      },
      {
        title: "연락처",
        dataIndex: "phone",
        className: "support-column-number fs-15 lh-21",
      },
      {
        title: "설명",
        dataIndex: "description",
        className: "support-column-number fs-15 lh-21",
      },
      {
        title: "지갑아이디",
        dataIndex: "userId",
        className: "support-column-number fs-15 lh-21",
        render: (value, row) => {
          if (!value) return (
              <Button>연동하기</Button>
            );
          else  return (
              <div style={{display:'flex', alignItems: 'center'}}>
                <div style={{paddingRight:'10px'}}>{value}</div>
                <Button onClick={()=>this.deleteId(row)}>삭제</Button>
              </div>
            );
        }
      },
      {
        title: "수정",
        dataIndex: "userId",
        className: "support-column-number fs-15 lh-21",
        render: (value, row) => <Button>수정</Button>
      },
      {
        title: "삭제",
        dataIndex: "userId",
        className: "support-column-number fs-15 lh-21",
        render: (value, row) => <Button onClick={()=>this.delete(row)}>삭제</Button>
      },

    ];

    return (
      <div>
        <div className="wrapper mt-35 width-1240" />
          <div className="flex-row flex-center" style={{paddingBottom: '10px', color: 'red'}}>
            * 최초 상점정보 생성은 로마켓 관리자에서 가능합니다. 생성 후 아래 서비스를 위해 지갑아이디를 연동해주세요.<br/>
            * 지갑아이디가 설정되어 있는 경우 사용자가 결제 시 상점에도 롬코인이 채굴되어 들어가게 됩니다.<br/>
            * 지갑아이디가 설정되어 있어야 정산 시 코인으로 지급하기가 가능합니다.
          </div>
          <div className="flex-row flex-center" style={{paddingBottom: '10px'}}>
            <Search
              placeholder={
                "검색어를 입력해주세요."
              }
              enterButton="검색"
              allowClear
              onSearch={this.onSearch}
              style={{ width: 400 }}
            />
          </div>
        <Table
          rowKey={(record) => record.idx}
          rowClassName={(record) => (record.deleted ? "gray" : "")}
          dataSource={tables}
          columns={columns}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
        />
      </div>
    );
  }
}

export default RomarketFranchise;
